import { render, staticRenderFns } from "./TypeSupplierForm.vue?vue&type=template&id=676c8a2f&"
import script from "./TypeSupplierForm.vue?vue&type=script&lang=js&"
export * from "./TypeSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports